import styled from 'styled-components'
import { theme } from 'styles/theme/hav-theme'

type TextProps = {
  family?: keyof typeof theme.typography.family
  weight?: keyof typeof theme.typography.weight
  size?: keyof typeof theme.typography.sizes
  lineHeight?: keyof typeof theme.typography.lineHeight
  decoration?: keyof typeof theme.typography.decoration
  align?: keyof typeof theme.typography.align
  color?: keyof typeof theme.colors.ion.neutral
  customColor?: string
  noWrap?: boolean
}

export const Text = styled.p.withConfig({
  shouldForwardProp: (prop) =>
    ![
      'family',
      'weight',
      'size',
      'lineHeight',
      'decoration',
      'align',
      'color',
      'customColor',
      'noWrap',
    ].includes(prop),
})<TextProps>`
  margin: 0;
  font-family: ${({ family }) =>
    family ? theme.typography.family[family] : theme.typography.family.primary};
  font-weight: ${({ weight }) =>
    weight ? theme.typography.weight[weight] : theme.typography.weight.sm};
  font-size: ${({ size }) => (size ? theme.typography.sizes[size] : theme.typography.sizes.sm)};
  line-height: ${({ lineHeight }) =>
    lineHeight ? theme.typography.lineHeight[lineHeight] : theme.typography.lineHeight.md};
  text-decoration: ${({ decoration }) =>
    decoration ? theme.typography.decoration[decoration] : 'none'};
  text-align: ${({ align }) => (align ? theme.typography.align[align] : 'left')};
  color: ${({ color, customColor }) =>
    customColor ? customColor : color ? theme.colors.ion.neutral[color] : 'inherit'};
  ${({ noWrap }) => noWrap && 'white-space: nowrap;'}
`
